import React, { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import 'bootstrap/dist/css/bootstrap.min.css';
import { FaUser, FaEnvelope, FaPhone, FaCheckCircle } from 'react-icons/fa';
import { getUserDetails, update_agent, updateUserDetails } from '../../../api/lead';

const UserSettings = () => {
  const location = useLocation();
  const [loadingData, setLoadingData] = useState(true);
  const [name, setName] = useState('');
  const [email, setEmail] = useState('');
  const [phone, setPhone] = useState('');
  const [onBreak, setOnBreak] = useState(false);
  const [updateMessage, setUpdateMessage] = useState('');

  const fetchData = async () => {
    setLoadingData(true);
    try {
      const userData = await getUserDetails();
      if (userData.status) {
        const { name, email, mobile, on_a_break } = userData.data;
        setName(name);
        setEmail(email);
        setPhone(mobile);
        setOnBreak(on_a_break);
      }
    } catch (error) {
      console.log("Error fetching data: ", error);
    }
    setLoadingData(false);
  };

  useEffect(() => {
    fetchData();
  }, [location.pathname]);

  const handleSubmit = async (e) => {
    e.preventDefault();

    // Trigger API call here if needed
    const update_data = {
        "name": name,
        "email": email,
        "phone": phone,
        "on_a_break": onBreak 
    }
    const response = await updateUserDetails(update_data)
    setUpdateMessage('Settings updated successfully!');
    setTimeout(() => setUpdateMessage(''), 3000); 
  };

  if (loadingData) {
    return (
      <div className="d-flex justify-content-center py-5">
        <div className="spinner-border" role="status">
          <span className="visually-hidden">Loading...</span>
        </div>
      </div>
    );
  }

  return (
    <div className="container py-5">
      <div className="row justify-content-center">
        <div className="col-lg-8 col-md-10">
          <div className="card shadow-lg border-0 rounded-4">
            <div className="card-body p-4 p-md-5">
              {updateMessage && (
                <div className="alert alert-success d-flex align-items-center rounded-3 mb-4" role="alert">
                  <FaCheckCircle className="flex-shrink-0 me-2" size={20} />
                  <div>{updateMessage}</div>
                </div>
              )}
              <form onSubmit={handleSubmit}>
                <div className="mb-4">
                  <label htmlFor="name" className="form-label d-flex align-items-center">
                    <FaUser size={18} className="me-2 text-primary" /> Full Name 
                  </label>
                  <input
                    type="text"
                    className="form-control form-control-lg rounded-3"
                    id="name"
                    value={name}
                    onChange={(e) => setName(e.target.value)}
                    placeholder="Enter your full name"
                  />
                </div>

                <div className="mb-4">
                  <label htmlFor="email" className="form-label d-flex align-items-center">
                    <FaEnvelope size={18} className="me-2 text-primary" /> Email Address
                  </label>
                  <input
                    type="email"
                    className="form-control form-control-lg rounded-3"
                    id="email"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    placeholder="Enter your email"
                  />
                </div>

                <div className="mb-4">
                  <label htmlFor="phone" className="form-label d-flex align-items-center">
                    <FaPhone size={18} className="me-2 text-primary" /> Phone Number
                  </label>
                  <input
                    type="tel"
                    className="form-control form-control-lg rounded-3"
                    id="phone"
                    value={phone}
                    onChange={(e) => setPhone(e.target.value)}
                    placeholder="Enter your phone number"
                  />
                </div>

                <hr className="my-4" />

                <div className="mb-4">
                  <label className="form-check-label d-flex align-items-center" htmlFor="onBreakSwitch">
                    <input
                      className="form-check-input flex-shrink-0 me-3"
                      type="checkbox"
                      role="switch"
                      id="onBreakSwitch"
                      checked={onBreak}
                      onChange={(e) => setOnBreak(e.target.checked)}
                    />
                    <span className="fw-bold">Currently On Break</span>
                    <span className="text-muted ms-2">(Tick if you are temporarily unavailable)</span>
                  </label>
                </div>

                <div className="d-grid gap-2 mt-5">
                  <button type="submit" className="btn btn-primary btn-lg rounded-3 shadow">
                    Update Settings
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default UserSettings;
